"use client";

import { useMemo } from "react";
import { format } from "date-fns";
import type { IFilter } from "../types";

const useFilterLabels = (
  filters: Pick<IFilter, "guests" | "checkIn" | "checkOut"> | null | undefined,
) => {
  const totalGuestsLabel = useMemo(() => {
    const { adults = 0, children = 0, infants = 0 } = filters?.guests || {};
    const total = adults + children + infants;
    return total === 0
      ? "Select Guests"
      : `${total} guest${total > 1 ? "s" : ""}`;
  }, [filters?.guests]);

  const dateRangeLabel = useMemo(() => {
    const { checkIn, checkOut } = filters || {};
    return checkIn && checkOut
      ? `${format(checkIn, "MMM d")} - ${format(checkOut, "MMM d")}`
      : "Select dates";
  }, [filters?.checkIn, filters?.checkOut]);

  return {
    totalGuestsLabel,
    dateRangeLabel,
  };
};

export default useFilterLabels;
